import { createBox } from "@shopify/restyle";
import { Theme } from "..";
import { GestureResponderEvent, TouchableOpacity } from "react-native";
import { useCallback } from "react";
import {trackEvent} from '../../utils'

const ExtendedTouchableOpacity = createBox<Theme, React.ComponentProps<typeof TouchableOpacity>>(TouchableOpacity);

interface ExtendedTouchableProps extends React.ComponentProps<typeof ExtendedTouchableOpacity> {
  eventName?: string;
  additionalProperties?: Record<string, any>
}

const ThemedTouchableOpacity = ({ onPress, eventName , children , additionalProperties ,...rest }: ExtendedTouchableProps) => {

  const eventProperties = {...(additionalProperties && { ...additionalProperties }) };

  const clickEventName = eventName + '_CLICKED'

  const handlePress = useCallback((event: GestureResponderEvent) => {
    if (eventName) {
      trackEvent(clickEventName ,eventProperties)
    }
    if (onPress) {
      onPress(event);
    }
  }, [onPress , eventName])

  return (
    <ExtendedTouchableOpacity onPress={handlePress} {...rest}>
      {children}
    </ExtendedTouchableOpacity>
  )
}

export default ThemedTouchableOpacity